var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "article-item img-16by9 item-type-article" },
    [
      _c("div", { staticClass: "article-wrap" }, [
        _c("div", { staticClass: "article-thumbnail" }, [
          _c(
            "a",
            {
              attrs: { href: _vm.matchUrl(_vm.article) },
              on: {
                click: function ($event) {
                  return _vm.onMatchClick($event, _vm.article)
                },
              },
            },
            [
              _c("div", { staticClass: "img-box" }, [
                _vm.lazyImgType
                  ? _c("img", {
                      staticClass: "lazy",
                      attrs: {
                        src: _vm.match_image(null, _vm.size),
                        "data-src": _vm.match_image(_vm.article, _vm.size),
                        alt: _vm.article.asset_title,
                      },
                    })
                  : _c("img", {
                      attrs: {
                        src: _vm.match_image(_vm.article, _vm.size),
                        alt: _vm.article.asset_title,
                        importance: "high",
                      },
                    }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "item-type-icon" }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "article-content" }, [
          _c(
            "a",
            {
              attrs: { href: _vm.matchUrl(_vm.article) },
              on: {
                click: function ($event) {
                  return _vm.onMatchClick($event, _vm.article)
                },
              },
            },
            [
              _c("p", { staticClass: "article-title" }, [
                _vm._v(_vm._s(_vm.article.asset_title)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "article-meta" }, [
            _c(
              "time",
              {
                staticClass: "meta meta-date",
                attrs: {
                  "data-date": _vm.getTimeSpan(
                    _vm.article.published_date,
                    true
                  ),
                },
              },
              [_vm._v(_vm._s(_vm.getTimeSpan(_vm.article.published_date)))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "article-description" }, [
            _c("p", [_vm._v(_vm._s(_vm.article.short_desc))]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }